"use strict";

import Common from "../Common";
import CommonGame from "../CommonGame";

//===================================================
//
// Constructor
//
//===================================================

function UndoManager() {
    // Constants.
    this.MAX_STACK_SIZE = 3;


    // Attributes.
    this._arrLayerState = [];


    // Signals.
    this.signals = {};
    this.signals.onStackEmpty = new signals.Signal();
    this.signals.onStackIncreased = new signals.Signal();
}
export default UndoManager;
//module.exports = UndoManager;
UndoManager.prototype.constructor = UndoManager;


//===================================================
//
// Public
//
//===================================================

UndoManager.prototype.save = function () {
    var drawlayerData = Common.game.canvas.drawLayer.context.getImageData(0, 0, Common.game.canvas.WIDTH, Common.game.canvas.HEIGHT);
    var drawDynOutlineData = Common.game.canvas.drawLayer.dynOutlineContext.getImageData(0, 0, Common.game.canvas.WIDTH, Common.game.canvas.HEIGHT);
    var fillLayerData = Common.game.canvas.fillLayer.colourContext.getImageData(0, 0, Common.game.canvas.WIDTH, Common.game.canvas.HEIGHT);
    var fillColourCodeData = Common.game.canvas.fillLayer.colourCodeContext.getImageData(0, 0, Common.game.canvas.WIDTH, Common.game.canvas.HEIGHT);

    if (this._arrLayerState.length == this.MAX_STACK_SIZE)
        this._arrLayerState.splice(0, 1);

    this._arrLayerState.push({
        drawlayerData: drawlayerData,
        drawDynOutlineData: drawDynOutlineData,
        fillLayerData: fillLayerData,
        fillColourCodeData: fillColourCodeData
    });

    // Signals.
    this.signals.onStackIncreased.dispatch();
};

UndoManager.prototype.undo = function () {
    if (this._arrLayerState.length == 0) return;

    var layerState = this._arrLayerState.splice(this._arrLayerState.length - 1, 1)[0];

    Common.game.canvas.fillLayer.setLayerData(layerState.fillLayerData, layerState.fillColourCodeData);
    Common.game.canvas.drawLayer.setLayerData(layerState.drawlayerData, layerState.drawDynOutlineData);

    // Signals.
    if (this._arrLayerState.length == 0)
        this.signals.onStackEmpty.dispatch();
};

UndoManager.prototype.clear = function () {
    this._arrLayerState = [];

    this.signals.onStackEmpty.dispatch();
};


//===================================================
//
// Private
//
//===================================================

// TODO:


//===================================================
//
// Events
//
//===================================================

// TODO:


//===================================================
//
// Getters / Setters
//
//===================================================

// TODO: